import { render, staticRenderFns } from "./ListaTipoEntrada.vue?vue&type=template&id=c4ed55a0"
import script from "./ListaTipoEntrada.vue?vue&type=script&lang=js"
export * from "./ListaTipoEntrada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports